import React from 'react'
import { Container, Col, Row, Card } from 'react-bootstrap'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'
const Clientes = ({ id }) => {
    const { allFile: { nodes: listadoImagenes } } = useStaticQuery(getFotosDestacados);

    return (
        <section className="page-section" >
            <div className="name-section" id={id}>
                <Container >
                    <Row className="justify-content-center">
                        <Col lg={8} className="text-center">
                            <h2 className="text-center mt-0 title-general">Clientes</h2>
                            <hr className="divider my-4" />
                            <p className="text-muted mb-5">
                                ¡Conoce algunas empresas factoring que optimizaron sus operaciones con nuestra plataforma!
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        {
                            listadoImagenes.map((item, index) => {
                                return (
                                    <Card key={index} className="item-cliente">
                                        <Card.Body className="p-3">
                                            <Image fluid={item.cliente.fluid} />
                                        </Card.Body>
                                    </Card>
                                )
                            })
                        }
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default Clientes


const getFotosDestacados = graphql`
    {
        allFile(filter: {sourceInstanceName: {eq: "clientes"}}) {
                nodes {
                    cliente:childImageSharp {
                        fluid {
                            ...GatsbyImageSharpFluid
                        }
                }
            }
        }
    }
`

